import { RefindIcon } from "../../base";
import { UserAuthButton } from "../UserAuthButton/UserAuthButton";
import { ThemeToggle } from "../ThemeToggle";
import styles from "./AppHeader.module.css";

export interface AppHeaderProps {
  isAuthenticated: boolean;
  fullName?: string | null;
  email?: string | null;
  avatarUrl?: string | null;
  onAuthClick: () => void;
  /** Desktop: avatar no sidebar, ocultar aqui */
  hideAuthOnDesktop?: boolean;
}

export const AppHeader = ({
  isAuthenticated,
  fullName,
  email,
  avatarUrl,
  onAuthClick,
  hideAuthOnDesktop = false,
}: AppHeaderProps) => {
  return (
    <header className={styles["app-header"]}>
      <div className={styles["app-header__branding"]}>
        <RefindIcon size={32} style={{ color: "var(--color-accent)" }} />
      </div>

      <div className={styles["app-header__actions"]}>
        <span className={styles["app-header__theme-wrap"]}>
          <ThemeToggle />
        </span>
        {!hideAuthOnDesktop && (
          <UserAuthButton
            isAuthenticated={isAuthenticated}
            fullName={fullName}
            email={email}
            avatarUrl={avatarUrl}
            onClick={onAuthClick}
          />
        )}
      </div>
    </header>
  );
};
